import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledRemove: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_remove"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="remove icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M20.2336 11.2289H3.77366C3.34759 11.2289 3.0022 11.5743 3.0022 12.0004C3.0022 12.3909 3.29243 12.7137 3.66898 12.7648L3.77366 12.7718H20.2336C20.6597 12.7718 21.0051 12.4264 21.0051 12.0004C21.0051 11.6098 20.7149 11.287 20.3383 11.236L20.2336 11.2289Z" />
      </svg>
    </span>
  );
};

export { FilledRemove };
